import { IAPICategoryModel } from "../interfaces/IAPIItemDetailPageCommonModel";

 
export class CategoryModel {
    id: string;
    name: string;
    constructor(data: Partial<CategoryModel>) {
        this.id = data?.id || '';
        this.name = data?.name || '';
    }

    static deserializeAPIModels(data: IAPICategoryModel[]): CategoryModel[] {
        const list: CategoryModel[] = [];

        if (Array.isArray(data)) {
            data.forEach((d) => {
                list.push(CategoryModel.deserializeAPIModel(d));
            });
        }
        return list;
    }

    createAPIModel(): IAPICategoryModel {
        return {
            id: this.id,
            name: this.name,
        };
    }

    static deserializeAPIModel(data: IAPICategoryModel): CategoryModel {
        const mappedData: Partial<CategoryModel> = {
            id: data.id,
            name: data.name,
        };
        return new CategoryModel(mappedData);
    }
}
